<button [class]="disableButton()" type="button">
    <fa-icon [icon]="icon"></fa-icon>
    <div class="icon-doubleText-btn-text">
      <span class="icon-doubleText-btn-text-title">{{title}}</span>
      <span class="icon-doubleText-btn-text-body">{{text}}</span>
    </div>
  </button>